var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 195.111,
    viewBox: "0 0 223 195.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        opacity: 0.15;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #dc505f;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #343434;\r\n        font-size: 22px;\r\n        font-family: Helvetica;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(-3771.118 -7317.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M3930.416,7444.487h-75.642a11.356,11.356,0,0,1-11.344-11.343V7332.325a11.357,11.357,0,0,1,11.344-11.344h54.412l32.573,32.932v79.231A11.355,11.355,0,0,1,3930.416,7444.487Zm-75.642-117.506a5.35,5.35,0,0,0-5.344,5.344v100.819a5.349,5.349,0,0,0,5.344,5.343h75.642a5.349,5.349,0,0,0,5.343-5.343v-76.765l-29.077-29.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M3908.012,7323.981v22.782a8.369,8.369,0,0,0,8.344,8.343h22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_738",
    "data-name": "Rectangle 738",
    d: "M15.556,0H60.093A15.555,15.555,0,0,1,75.647,15.555V26.222A15.555,15.555,0,0,1,60.092,41.777H15.556A15.556,15.556,0,0,1,0,26.221V15.556A15.556,15.556,0,0,1,15.556,0Z",
    transform: "translate(3826.404 7352.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M3886.5,7397.709h-44.538a18.576,18.576,0,0,1-18.554-18.556v-10.666a18.576,18.576,0,0,1,18.554-18.555H3886.5a18.575,18.575,0,0,1,18.555,18.555v10.666A18.576,18.576,0,0,1,3886.5,7397.709Zm-44.538-41.777a12.569,12.569,0,0,0-12.554,12.555v10.666a12.569,12.569,0,0,0,12.554,12.556H3886.5a12.57,12.57,0,0,0,12.555-12.556v-10.666a12.569,12.569,0,0,0-12.555-12.555Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M3905.385,7429.854v-26h-26v26h-13.709l26.545,32.964,26.545-32.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M3892.221,7467.6l-32.813-40.747h16.978v-26h32v26h16.648Zm-20.278-34.747,20.278,25.181,20.278-25.181h-10.113v-26h-20v26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M3841.354,7366.145h8.048a5.457,5.457,0,0,1,3.853,1.352,4.912,4.912,0,0,1,1.468,3.8,5.521,5.521,0,0,1-1.31,3.666,4.93,4.93,0,0,1-4.007,1.561h-5.615v7.6h-2.437Zm9.449,2.473a5.227,5.227,0,0,0-2.2-.38h-4.812v6.232h4.812a4.578,4.578,0,0,0,2.644-.7,2.774,2.774,0,0,0,1.015-2.461A2.708,2.708,0,0,0,3850.8,7368.618Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M3857.955,7366.145h7.188a6.74,6.74,0,0,1,5.678,2.632,9.79,9.79,0,0,1,1.8,6.084,12.261,12.261,0,0,1-1.064,5.179,6.555,6.555,0,0,1-6.439,4.089h-7.164Zm6.71,15.9a6.475,6.475,0,0,0,1.988-.257,4.4,4.4,0,0,0,2.274-1.837,7.646,7.646,0,0,0,1.017-2.791,10.877,10.877,0,0,0,.18-1.885,8.928,8.928,0,0,0-1.3-5.191,4.753,4.753,0,0,0-4.183-1.849h-4.226v13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M3876.184,7366.145h12.475v2.2H3878.62v5.46h8.827v2.143h-8.827v8.178h-2.436Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    className: "cls-2",
    d: "M3927.416,7441.487h-75.642a11.356,11.356,0,0,1-11.344-11.343V7329.325a11.357,11.357,0,0,1,11.344-11.344h54.412l32.573,32.932v79.231A11.355,11.355,0,0,1,3927.416,7441.487Zm-75.642-117.506a5.35,5.35,0,0,0-5.344,5.344v100.819a5.349,5.349,0,0,0,5.344,5.343h75.642a5.349,5.349,0,0,0,5.343-5.343v-76.765l-29.077-29.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    className: "cls-2",
    d: "M3905.012,7320.981v22.782a8.369,8.369,0,0,0,8.344,8.343h22.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_739",
    "data-name": "Rectangle 739",
    className: "cls-2",
    d: "M15.556,0H60.093A15.555,15.555,0,0,1,75.647,15.555V26.222A15.555,15.555,0,0,1,60.092,41.777H15.555A15.555,15.555,0,0,1,0,26.222V15.556A15.556,15.556,0,0,1,15.556,0Z",
    transform: "translate(3823.404 7349.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    className: "cls-3",
    d: "M3883.5,7394.709h-44.538a18.576,18.576,0,0,1-18.554-18.556v-10.666a18.576,18.576,0,0,1,18.554-18.555H3883.5a18.575,18.575,0,0,1,18.555,18.555v10.666A18.576,18.576,0,0,1,3883.5,7394.709Zm-44.538-41.777a12.569,12.569,0,0,0-12.554,12.555v10.666a12.569,12.569,0,0,0,12.554,12.556H3883.5a12.57,12.57,0,0,0,12.555-12.556v-10.666a12.569,12.569,0,0,0-12.555-12.555Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-2",
    d: "M3902.385,7426.854v-26h-26v26h-13.709l26.545,32.964,26.545-32.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    className: "cls-3",
    d: "M3889.221,7464.6l-32.813-40.747h16.978v-26h32v26h16.648Zm-20.278-34.747,20.278,25.181,20.278-25.181h-10.113v-26h-20v26Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-3",
    d: "M3838.354,7363.145h8.048a5.457,5.457,0,0,1,3.853,1.352,4.912,4.912,0,0,1,1.468,3.8,5.521,5.521,0,0,1-1.31,3.666,4.93,4.93,0,0,1-4.007,1.561h-5.615v7.6h-2.437Zm9.449,2.473a5.227,5.227,0,0,0-2.2-.38h-4.812v6.232h4.812a4.578,4.578,0,0,0,2.644-.7,2.774,2.774,0,0,0,1.015-2.461A2.708,2.708,0,0,0,3847.8,7365.618Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-3",
    d: "M3854.955,7363.145h7.188a6.74,6.74,0,0,1,5.678,2.632,9.79,9.79,0,0,1,1.8,6.084,12.261,12.261,0,0,1-1.064,5.179,6.555,6.555,0,0,1-6.439,4.089h-7.164Zm6.71,15.9a6.475,6.475,0,0,0,1.988-.257,4.4,4.4,0,0,0,2.274-1.837,7.646,7.646,0,0,0,1.017-2.791,10.877,10.877,0,0,0,.18-1.885,8.928,8.928,0,0,0-1.3-5.191,4.753,4.753,0,0,0-4.183-1.849h-4.226v13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-3",
    d: "M3873.184,7363.145h12.475v2.2H3875.62v5.46h8.827v2.143h-8.827v8.178h-2.436Z"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "Click_to_download_PDF",
    "data-name": "Click to download PDF",
    className: "cls-4",
    transform: "translate(3771.118 7508.092)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Click to download PDF")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownloadIcon);
export default __webpack_public_path__ + "static/media/pdf_download_icon.b705dfdd35152586a38ac82c1156ab11.svg";
export { ForwardRef as ReactComponent };